import React, { useEffect, useState } from 'react'
import ListGroup from '../../userPages/partials/ListGroup'
import UserHero from '../../userPages/partials/UserHero'
import { CiCirclePlus } from "react-icons/ci";
import { Link } from 'react-router-dom';
import { MdDeleteForever } from "react-icons/md";
import { FaFrownOpen } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import toast from 'react-hot-toast';
import UserAccount from '../../userPages/partials/UserAccount';

export default function  Testimonial () {
    let [data,setData] = useState([])


async function deleteData(_id) {
    if (window.confirm("Are You Sure to Delete that Item?")) {
      try {
        let response = await fetch(`/api/testimonial/${_id}`, {
          method: "DELETE",
          headers: {
            "content-type": "application/json"
          }
        });
  
        response = await response.json();
  
        if (response.result === "Done") {
          toast.success("Deleted Successfully");
          // 🔄 Refresh data after deletion
          getApiData();
        } else {
          toast.error("Failed to delete!");
        }
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong!");
      }
    }
  }
  



async function getApiData() {
    let response = await fetch( "/api/testimonial" , {
           method :"GET",
           headers:{
            "content-type":"application/json",
              // "authorization":localStorage.getItem("token")
                  }
    })

    response = await response.json()
    
    if(response.result ==="Done"){
        setData(response.data)
    }    
}



useEffect(()=>{
    getApiData()
} ,[data?.length])
  return (
    <>
    <UserHero/>
       <div className="container">
         <UserAccount/>
                <div className="row my-3">
                 
                    <ListGroup/>
                  
                  <div className="col-md-8">
         <h1 className=' testimonials-h1 text-light text-center p-2' style={{background:"#"}}>Testimonial Table <Link to="/admin/create-testimonial"> <CiCirclePlus className='float-end text-light' /> </Link></h1>
         <div className="table-responsive">
             {
                data.length?

                <table className='table table-bordered responsive'>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Pic</th>
                        <th>Message</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item,index)=>{
                            return <tr key={index}>
                                <td>{item._id}</td>
                                <td>{item.name}</td>
                                <td>
                                    {/* <Link to={`${item.pic}`}> */}
                                    <img src={`${item.pic}`} loading="lazy" alt="testimonila-table-img" height={50} width={50}  />
                                    {/* </Link> */}
                                </td>
                                <td >
                                    <div style={{overflow:"auto", height:"100px" , width:"300px"}}>
                                    {item.message}

                                    </div>
                                    </td>
                                <td>
                                    <Link to={`/admin/update-testimonial/${item._id}`}>
                                   <CiEdit   className='testimonil-table-btn' style={{height:"30", width:"50",color:"blue" }} />
                                   </Link>     
                                </td>
                                <td>
                               
                                <MdDeleteForever className='testimonil-table-btn' style={{height:"30", width:"50", }} onClick={() => deleteData(item._id)} />
                            
                                </td>

                            </tr>
                        })
                    }
                </tbody>
              </table>
              :
              <div className="not-testinomonil">
                <h3>Sorry! <FaFrownOpen />  Testimonial Record Not Found!!</h3>
                
              </div>
             }
            
                  </div>
              </div>
              </div>
       </div>
    </>
  )
}
